import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { ClinicServiceProviderComponent } from './clinic-service-provider.component';
import { ClinicServiceProviderRoutesModule } from './clinic-service-provider.routes';
import { TinymceModule } from 'angular2-tinymce';
import { baseUrl } from '../../environments/environment';
import { SharedPopoverModule } from '../shared/popover/popover.module';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    imports: [
        BaseModule,
        ClinicServiceProviderRoutesModule,
        MatSlideToggleModule,
        SharedPopoverModule,
        BreadcrumbModule
    ],
    declarations: [
        ClinicServiceProviderComponent
    ]
})
export class ClinicServiceProviderModule {
}
